import { NgModule } from "@angular/core";
import { AdministrationComponent } from "./administration.component";
import { UsersAndRolesComponent } from "./users-roles/users-roles.component";
import { MenuModule } from "../menu/menu.module";
import { EditUserComponent } from "./users-roles/edit-user/edit-user.component";
import { FacilitiesComponent } from "./facilites/facilities.component";
import { CreateFacilityComponent } from "./facilites/create-facility.component";
import { EditFacilityComponent } from "./facilites/edit-facility.component";
import { PickListsComponent } from "./picklists/picklists.component";
import { AddFieldComponent } from "./picklists/add-field.component";
import { AddValueComponent } from "./picklists/add-value.component";
import { EditFieldComponent } from "./picklists/edit-field.component";
import { EditValueComponent } from "./picklists/edit-value.component";

const componentList = [
  AdministrationComponent,
  UsersAndRolesComponent,
  EditUserComponent,
  FacilitiesComponent,
  CreateFacilityComponent,
  EditFacilityComponent,
  PickListsComponent,
  AddFieldComponent,
  AddValueComponent,
  EditFieldComponent,
  EditValueComponent,
];

@NgModule({
  imports: [MenuModule],
  declarations: [componentList],
})
export class AdministrationModule {}
